import axios from '@axios'

const route = 'configuration/schedule'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    /**
     * salva o numero de whatsapp      */
    saveWhatsappNumber(context, whatsappNumber) {
      return axios.post(`${route}/whatsapp`, { whatsapp_number: whatsappNumber })
    },

    /**
     * delete o numero de whatsapp
     */
    deleteWhatsappNumber(context) {
      return axios.delete(`${route}/whatsapp`)
    }
  },
}
